export enum ServiceCategoryType {
  IN_HOUSE = 'IN_HOUSE',
  EXPERT = 'EXPERT',
  PENDING = 'PENDING',
  DUPONT = 'DUPONT',
  INVOICE = 'INVOICE',
}
